/** トーストが自動で閉じ始めるまでの表示時間（ms） */
export const DEFAULT_TOAST_DURATION = 2700;

/** 閉じるアニメーションの再生時間（ms）。styles.module.scss / presentation/styles.module.scss の 0.3s と対応 */
export const CLOSE_ANIMATION_DURATION = 300;
